module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/birthdays/birthdays.component.css
// module id = ./src/app/birthdays/birthdays.component.css
// module chunks = main